const createSystem = {
  createSystem: {
    selectSystem:
      'Select a system for which you want the design review service:',
    residential: 'Residential',
    commercial: 'Commercial',
    selectfromList:
      'Select from a list of systems already created in Enlighten',
    enterSystemName: 'Please enter the system name',
    siteSelectionErrorMsg1: 'You have selected a ',
    siteSelectionErrorMsg2: ' system. Please select ',
    siteSelectionErrorMsg3: ' system to continue.',
    commercialErrorMsg: 'commercial',
    residentialErrorMsg: 'residential',
    createNewSystem: 'Create a new system in Enlighten',
    systemName: 'System Name',
    type: 'Type',
    thirdParty: 'Third Party Owned (ex: PPA or Leased)',
    siteInformation: 'Site Information',
    collapse: 'Collapse',
    expand: 'Expand',
    customerName: 'Customer Name',
    address: 'Address',
    zipCode: 'Zip Code',
    noOfMicroinverters: 'No. Of Microinverters',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    enlightenVersion: 'Enlighten Version',
    myEnlighten: 'MyEnlighten',
    monitoring:
      'Owner will receive MyEnlighten for system performance monitoring.',
    location: 'Location',
    streetAddress1: 'Street Address 1',
    streetAddress2: 'Street Address 2',
    required: 'Required',
    zipCodePostal: 'Zip/Postal Code',
    invalidPhoneNumber: 'Invalid Phone Number',
    invalidEmail: 'Invalid Email',

    owner: 'Owner',
    country: 'Country',
    state: 'State/Province',
    city: 'City',
    deviceDetails: 'Device Details',
    enphaseGuideLine:
      'Enphase provides guidance and resources to assist installers in designing a system within appropriate parameters. The installer and qualified electrician are responsible for final design and implementation.',
    confirm: 'I confirm the following',
    authorized:
      'I am authorized to register for Enlighten on behalf of the system owner/host, who has given me permission to submit this information to Enphase on their behalf.',
    readUnderstand: 'I have read and understand Enphase’s',
    privacyPolicy: ' Privacy Policy',
    and: 'and',
    terms: 'Terms of Service',
    policy: 'the “Policies”',
    acknowledge:
      'The system owner/host has acknowledged that they have read and understand the Policies.',
    informedSystemOwner:
      'I have informed the system owner/host that my company will be able to monitor their energy consumption amounts and times of usage and that they may revoke this permission at any time',
    agreedForTerms1:
      'I have read and agreed to the Enphase Design Review Services',
    agreedForTerms2: '',
    termsAndCondition: 'Terms and Conditions',
    proceedCreateSystem: 'Proceed without linking/creating any system',
    cancel: 'Cancel',
    noOption: 'No options',
    australia: 'Australia',
    usa: 'United States',
    germany: 'Germany',
    belgium: 'Belgium',
    austria: 'Austria',
    netherlands: 'Netherlands',
    france: 'France',
    switzerland: 'Switzerland',
  },
};

export default createSystem;
